import styled from 'styled-components'

const OrangeLink = styled.a`
  color: ${props => props.theme.colors.orange};
  font-weight: 600;
  text-decoration: none;
`

export default OrangeLink
